module.exports = __webpack_public_path__ + "img/semin_allen_heath.7ce60d66.jpg";